
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 14","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.455.498H.545v12.954h10.91V.498z","stroke":"currentColor","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M2.738 3.285h4.364","stroke":"currentColor","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M2.728 6.996h6.545","stroke":"currentColor","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M2.728 9.715h6.545","stroke":"currentColor","stroke-miterlimit":"10"}})])
          )
        }
      }
    